import Header from 'components/Header/Header';
import NavBar from 'components/NavBar';
import RightGif from 'components/RightGif';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { twMerge } from 'tailwind-merge';

const RulePage = () => {
  const [dataSettings, setDataSettings] = useState([]);

  useEffect(() => {
    fetchAllSetting();
  }, []);

  const fetchAllSetting = async () => {
    try {
      const res = await getAllSetting({ site: SITE });
      setDataSettings(res?.data || []);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <RightGif />

      <div className="container relative z-10 pb-[110px] md:pb-[32px] px-2">
        <Header />
        <div className="mx-auto max-w-[1280px] mt-2 bg-[#FFFFFF99] p-4 w-full md:pb-8 md:pt-4 rounded-2xl backdrop-blur-[48.53px]">
          <div style={{ fontFamily: 'Roboto, Arial, sans-serif', color: '#2a2a2a' }}>
            <div className="text-center font-black text-[24px] md:text-[32px] leading-[30px] md:leading-[38px] text-[#25abe0] my-2 md:my-4 uppercase tracking-wide">
              THỂ LỆ
            </div>

            <div className="text-[13px] md:text-[15px] leading-[20px] md:leading-[22px] mb-3">
              <div className="mb-1">
                <span className="font-bold">Đối tượng áp dụng:</span>
                <span className="ml-1">Toàn bộ hội viên</span>
              </div>
              <div className="mb-1">
                <span className="font-bold">Thời gian sự kiện:</span>
                <span className="ml-1">World Cup</span>
              </div>
              <div className="mt-1">
                Mùa World Cup sôi động đã chính thức khởi tranh. Jun88 triển khai chương trình
                khuyến mãi đặc biệt dành riêng cho hội viên VIP, Càng nâng cấp - Càng nhận thưởng
                lớn, hòa mình vào không khí bóng đá cuồng nhiệt trên toàn thế giới.
              </div>
              <div className="my-1">
                Áp dụng cho hội viên hợp lệ có tổng nạp từ ngày hôm trước đến thời điểm dự đoán ≥
                300 điểm trước khi dự đoán.
              </div>
            </div>

            <div className="w-full overflow-x-auto">
              <table className="w-full border-separate border-spacing-[2px] md:border-spacing-[6px] table-fixed mx-auto">
                <thead>
                  <tr>
                    <th className="hidden md:table-cell bg-[#25abe0] text-white font-bold text-[10px] md:text-[14px] leading-[14px] md:leading-[16px] p-[5px_3px] md:p-[10px_8px] rounded-[6px] md:rounded-[10px] text-center">
                      Danh mục
                    </th>
                    <th className="bg-[#25abe0] text-white font-bold text-[10px] md:text-[14px] leading-[14px] md:leading-[16px] p-[5px_3px] md:p-[10px_8px] rounded-[6px] md:rounded-[10px] text-center">
                      Danh mục
                    </th>
                    <th className="bg-[#25abe0] text-white font-bold text-[10px] md:text-[14px] leading-[14px] md:leading-[16px] p-[5px_3px] md:p-[10px_8px] rounded-[6px] md:rounded-[10px] text-center">
                      VIP0
                    </th>
                    <th className="bg-[#25abe0] text-white font-bold text-[10px] md:text-[14px] leading-[14px] md:leading-[16px] p-[5px_3px] md:p-[10px_8px] rounded-[6px] md:rounded-[10px] text-center">
                      VIP6+
                    </th>
                    <th className="bg-[#25abe0] text-white font-bold text-[10px] md:text-[14px] leading-[14px] md:leading-[16px] p-[5px_3px] md:p-[10px_8px] rounded-[6px] md:rounded-[10px] text-center">
                      VIP20+
                    </th>
                    <th className="bg-[#25abe0] text-white font-bold text-[10px] md:text-[14px] leading-[14px] md:leading-[16px] p-[5px_3px] md:p-[10px_8px] rounded-[6px] md:rounded-[10px] text-center">
                      VIP30+
                    </th>
                    <th className="bg-[#25abe0] text-white font-bold text-[10px] md:text-[14px] leading-[14px] md:leading-[16px] p-[5px_3px] md:p-[10px_8px] rounded-[6px] md:rounded-[10px] text-center">
                      VIP40+
                    </th>
                    <th className="bg-[#25abe0] text-white font-bold text-[10px] md:text-[14px] leading-[14px] md:leading-[16px] p-[5px_3px] md:p-[10px_8px] rounded-[6px] md:rounded-[10px] text-center">
                      VIP50+
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      rowSpan="2"
                      className="hidden md:table-cell bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px] leading-[13px] md:leading-[16px]"
                    >
                      Phát thưởng sau khi
                      <br />
                      trận đấu kết thúc
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px] leading-[13px] md:leading-[16px]">
                      Tỷ số trận đấu
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      10
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      18
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      28
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      38
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      58
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      268
                    </td>
                  </tr>
                  <tr>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px] leading-[13px] md:leading-[16px]">
                      Bàn thắng đầu
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      18
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      28
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      58
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      88
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      108
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      388
                    </td>
                  </tr>
                  <tr>
                    <td
                      rowSpan="3"
                      className="hidden md:table-cell bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px] leading-[13px] md:leading-[16px]"
                    >
                      Phát thưởng sau
                      <br />
                      World Cup
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px] leading-[13px] md:leading-[16px]">
                      Đội vô địch WC
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      28
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      58
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      78
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      108
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      168
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      588
                    </td>
                  </tr>
                  <tr>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px] leading-[13px] md:leading-[16px]">
                      Vua phá lưới
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      58
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      98
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      138
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      188
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      268
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      688
                    </td>
                  </tr>
                  <tr>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px] leading-[13px] md:leading-[16px]">
                      Đội Châu Á vào sâu nhất
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      28
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      48
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      78
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      108
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      178
                    </td>
                    <td className="bg-white border border-[#d7e7f5] rounded-[6px] md:rounded-[10px] text-center p-[5px_3px] md:p-[10px_8px] font-bold text-[#0b4a6a] text-[10px] md:text-[14px]">
                      488
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mt-3 text-[12px] md:text-[14px] leading-[20px] md:leading-[22px] text-[#333333]">
              <div className="my-1">- Tiền thưởng sẽ cộng trực tiếp vào tài khoản game</div>
              <div className="my-1">- Trải qua 1 vòng cược là có thể rút tiền.</div>
              <div className="my-1">
                - Thời hạn nhận thưởng là 72 giờ kể từ khi phát thưởng; quá thời hạn sẽ được xem là
                tự động từ bỏ ưu đãi.
              </div>
              <div className="my-1">
                - Hội viên có hành vi lợi dụng khuyến mãi, giao dịch đối ứng, vi phạm quy định công
                ty hoặc thuộc danh sách không được chấp nhận cược sẽ không được tham gia chương
                trình.
              </div>
            </div>
          </div>
        </div>
      </div>
      <NavBar />
    </div>
  );
};

export default RulePage;
